import {
  faChevronRight,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useHandleSagaError } from '»utils/customHooks';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { disclaimersServices } from './trlDisclaimer.service';
import {
  ArrowRightIconStyled,
  DisclaimerHeadStyled,
  DisclaimerStyled,
  MainIconStyled,
  TextContainerStyled,
  TextStyled,
  WrapperStyled,
} from './TrlDisclaimer.styles';

export const TrlDisclaimer = ({
  disclaimerId,
  operationType,
  symbol,
  exchange,
  securityType,
  expressionId,
  expressionParams,
  isModal,
}) => {
  const [disclaimer, setDisclaimer] = useState(null);

  const { handleSagaError } = useHandleSagaError();

  useEffect(() => {
    if (disclaimerId)
      disclaimersServices
        .getDisclaimer({
          context: disclaimerId,
          operationType,
          symbol,
          exchange,
          securityType,
        })
        .then((resp) => {
          if (resp && resp.length > 0) {
            const {
              body,
              checkboxNote,
              collapsed,
              heading,
              mandatory,
              withCheckbox,
            } = resp[0];

            setDisclaimer({
              body,
              checkboxNote,
              collapsed,
              heading,
              mandatory,
              withCheckbox,
            });
          }
        })
        .catch((error) => {
          handleSagaError(error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disclaimerId, operationType, symbol, exchange, securityType]);

  return (
    <DisclaimerStyled
      reduceSizes={isModal && !expressionId}
      noMargintop={isModal && expressionId}
      id="divDisclaimer"
    >
      {disclaimerId && disclaimer && (
        <>
          <WrapperStyled>
            <DisclaimerHeadStyled>{disclaimer.heading}</DisclaimerHeadStyled>
          </WrapperStyled>
          <TextContainerStyled hasHeading={disclaimer.heading}>
            {isModal && <ArrowRightIconStyled icon={faChevronRight} />}
            <TextStyled reduceSizes={isModal && !expressionId}>
              {disclaimer.body}
            </TextStyled>
          </TextContainerStyled>
        </>
      )}
      {expressionId && (
        <>
          <WrapperStyled>
            <MainIconStyled icon={faCircleCheck} />
            <DisclaimerHeadStyled>
              <FormattedMessage id="TRLT_UI-ORD_SENT_SUCC" />
            </DisclaimerHeadStyled>
          </WrapperStyled>
          <TextContainerStyled hasHeading>
            <TextStyled>
              {TrlFormattedMessagePlain({
                id: expressionId,
                values: expressionParams,
              })}
            </TextStyled>
          </TextContainerStyled>
        </>
      )}
    </DisclaimerStyled>
  );
};

TrlDisclaimer.propTypes = {
  disclaimerId: PropTypes.string,
  operationType: PropTypes.string,
  symbol: PropTypes.string,
  exchange: PropTypes.string,
  securityType: PropTypes.string,
  expressionId: PropTypes.string,
  expressionParams: PropTypes.number,
  isModal: PropTypes.bool,
};
